const host = require('./distribution/host');

module.exports = host;
